"use client";

import { useState, useEffect } from "react";
import Link from "next/link";

export default function HomeSticky() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
  const [isIndianUser, setIsIndianUser] = useState(false);
  const [locationChecked, setLocationChecked] = useState(false);

  useEffect(() => {
    // Show banner after scrolling
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const detectUserLocation = () => {
      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const indianTimezones = ["Asia/Kolkata", "Asia/Calcutta"];
        const isIndian = indianTimezones.includes(timezone);
        setIsIndianUser(isIndian);
      } catch (error) {
        console.error("Error detecting timezone:", error);
        setIsIndianUser(false);
      } finally {
        setLocationChecked(true);
      }
    };

    detectUserLocation();
  }, []);

  useEffect(() => {
    // Countdown timer
    if (timeLeft > 0 && isVisible) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            return 180; // Reset to 3 minutes when it reaches 0
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timeLeft, isVisible]);

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div
      className={`fixed bottom-0 left-0 w-full bg-[#fffaf1] border-t border-gray-200 py-3 md:py-4 transition-transform duration-300 z-50 ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="w-[90%] md:w-[80%] mx-auto flex flex-row items-center justify-between gap-3 md:gap-4">
        {/* Left side: Icon + Text + Timer */}
        <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0">
          {/* Text and Timer */}
          <div className="flex flex-col min-w-0">
            <h3 className="text-[#002726] text-base md:text-xl font-medium leading-tight">
              <span className="font-bold"> FREE </span>
              {locationChecked ? (
                isIndianUser ? (
                  <del>₹1,999</del>
                ) : (
                  <del>$100</del>
                )
              ) : null}
            </h3>
            <p className="text-[#002726] text-xs md:text-base  leading-tight">
            3 Hour AI Workshop
            </p>
          </div>
        </div>

        {/* Right side: Button */}
        <div className="flex items-center flex-shrink-0">
          <Link
            href={
              isIndianUser
                ? "https://applications.growthschool.io/3472/18536"
                : "https://applications.growthschool.io/4462/18604"
            }
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-4 py-2 md:px-6 md:py-3 bg-[#33c375] text-black text-sm md:text-base font-medium rounded-lg hover:bg-[#43a047] transition-colors whitespace-nowrap"
          >
            Claim your spot
          </Link>
        </div>
      </div>
    </div>
  );
}
